<template>
  <div class="body-page">
    <h6 class="fw-bold">Lista de usuários</h6>
    <div class="d-flex justify-content-end my-3">
      <Button @click="getUsers()" icon="pi pi-sync" class="p-button-warning p-button-sm me-2" />
      <Button @click="openModalAdd()" label="Adicionar Usuário" icon="pi pi-user-plus" class="p-button-success p-button-sm" />
    </div>

    <Table :users="users" :loading="loading" />
    <ModalAdd ref="modalAdd" />
  </div>
</template>

<script>
import Table from '@/components/pages/users/Table'
import Button from 'primevue/button'
import ModalAdd from '@/components/pages/users/ModalAdd'

export default {
  name: 'Users',

  components: {
    Table,
    Button,
    ModalAdd
  },

  data() {
    return {
      users: [],
      loading: true
    }
  },

  methods: {
    async getUsers() {
      this.loading = true
      
      await this.$api.get('/users')
        .then((response) => {
          this.users = response.data.users
          this.loading = false
        })
        .catch((err) => {
          this.$toastr.e(err.response.data.message, 'Erro')
        })
    },

    openModalAdd() {
      this.$refs.modalAdd.openModal()
    }
  },

  created() {
    this.getUsers()
  }
}
</script>

<style lang="scss">
.body-page {
  width: 100%;

  padding: 20px;

  border-radius: 10px;
  border: 1px solid gainsboro;
  background: white;
}
</style>